import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import DevelopmentSiteStatusSelector from '../components/DevelopmentSiteStatusSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalConfigurationState>({
    configuration: selectConfiguration(),
  }),
)(DevelopmentSiteStatusSelector)
